import { ApkReducer } from "./Redux/Reducers/ApkReducer";
import { EditorReducer } from "./Redux/Reducers/EditorReducer";
import { ContentReducer } from "./Redux/Reducers/contentReducer";
import { templateReducer } from "./Redux/Reducers/templateReducer";
import { formReducer } from "./Redux/Reducers/formReducer";
import { screenReducer } from "./Redux/Reducers/screenReducer";
import { userReducer } from "./Redux/Reducers/userReducer";
import { contextReducer } from "./Redux/Reducers/contextReducer";

const { combineReducers } = require("redux");
const { playlistReducer } = require("./Redux/Reducers/playlistReducer");

export const rootReducer=combineReducers({
    Playlist:playlistReducer,
    Screen:screenReducer,
    Content:ContentReducer,
    Templates:templateReducer,
    Form:formReducer,
    User:userReducer,
    Editor:EditorReducer,
    Apk:ApkReducer,
    Context:contextReducer
})